// Derives a single profession category from a namebearer's English `desc`.
// The directory facts are English-only, so category matching is keyword-based.
// Order matters: the first category with a matching keyword wins.

export const CATEGORY_ORDER = [
  "sport",
  "music",
  "screen",
  "writing",
  "science",
  "military",
  "clergy",
  "politics",
  "business",
  "arts",
  "other",
];

// English fallback labels (used for the 44 extra locales that don't ship
// translated category names). Kept short for chip display.
export const DEFAULT_CATEGORY_LABELS = {
  sport: "Sport",
  music: "Music",
  screen: "Stage & Screen",
  writing: "Writing",
  science: "Science",
  military: "Military",
  clergy: "Faith",
  politics: "Politics",
  business: "Business",
  arts: "Arts",
  other: "Other",
};

const KEYWORDS = {
  sport: [
    "player", "athlete", "soccer", "footballer", "football", "hockey",
    "basketball", "baseball", "tennis", "cricket", "cricketer", "rugby",
    "snooker", "curler", "swimmer", "badminton", "golfer", "boxer",
    "cyclist", "skier", "rower", "wrestler", "sprinter", "vaulter",
    "water polo", "olympic", "coach", "gymnast", "sport", "racer",
  ],
  music: [
    "musician", "singer", "composer", "songwriter", "pianist", "guitarist",
    "drummer", "violinist", "jazz", "rapper", "conductor", "music",
  ],
  screen: [
    "actor", "actress", "comedian", "filmmaker", "film ", "screenwriter",
    "television", "stage designer", "stage director",
  ],
  writing: [
    "writer", "author", "poet", "novelist", "journalist", "playwright",
    "historian",
  ],
  science: [
    "physicist", "scientist", "chemist", "biologist", "professor",
    "mathematician", "engineer", "economist", "astronomer", "physician",
    "psychologist", "researcher", "academic",
  ],
  military: [
    "admiral", "general", "soldier", "military", "navy", "army", "colonel",
    "commander", "marine", "officer", "air force",
  ],
  clergy: [
    "clergyman", "bishop", "priest", "pastor", "theologian", "rabbi",
    "chaplain", "missionary",
  ],
  politics: [
    "politician", "senator", "parliament", "governor", "mayor", "congress",
    "diplomat", "president", "statesman", "activist", "leader",
  ],
  business: [
    "businessman", "entrepreneur", "executive", "founder", "industrialist",
    "banker", "lawyer", "judge", "attorney",
  ],
  arts: [
    "artist", "painter", "sculptor", "designer", "architect", "photographer",
    "director", "producer",
  ],
};

export function categorize(desc = "") {
  const d = desc.toLowerCase();
  for (const cat of CATEGORY_ORDER) {
    const kws = KEYWORDS[cat];
    if (kws && kws.some((k) => d.includes(k))) return cat;
  }
  return "other";
}
